import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NextLocationsBridgeEffects } from './+state/next-locations-bridge.effects';
import { NextLocationsCacheEffects } from './+state/next-locations-cache.effects';
import { NextOfflineStoreLocationsEffects } from './+state/next-locations-offline.effects';
import { NextLocationsPageEffects } from './+state/next-locations-page.effects';
import { NextLocationsApiEffects } from './+state/next-locations.effects';
import { nextLocationsFeature } from './+state/next-locations.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nextLocationsFeature),
    EffectsModule.forFeature([
      NextLocationsApiEffects,
      NextLocationsBridgeEffects,
      NextLocationsCacheEffects,
      NextLocationsPageEffects,
      NextOfflineStoreLocationsEffects,
    ]),
  ],
})
export class NextLocationsDataAccessModule {}
